module.exports = __webpack_public_path__ + "static/media/logo_sq.9eca6cca.png";